import { Paper, Typography } from '@mui/material'
import logo from 'assets/logo-conducco-all-white.svg'
import { useStyles } from './styles'

const DashBoardAdmin = () => {
  const classes = useStyles()

  return (
    <Paper elevation={3} className={classes.paper}>
      <img src={logo} alt='conducco' className={classes.logo} />
      <Typography variant='subtitle1' className={classes.homeText}>
        Criando conexões entre Sellers e Buyers.
      </Typography>
    </Paper>
  )
}

export default DashBoardAdmin
